<template>
  <div id="gitapp">
    <h2>💥What's new </h2>

    <ul v-for="app in recentapps" v-bind:key="`first-${app.name}`">
      <li>{{ app.name }} v{{ app.version }} ({{ app.date }})</li>
    </ul>


  </div>
</template>

<script>
export default {
  name: "HistoryComponent",
  props: ["recentapps"],
  data() {
    return {
    };
  },
  beforeCreate() {
    // At this time, |this.apps| is not defined
    // console.log(this.apps)
    // console.log("GitApp:beforeCreate")
  },
  created() {
    // console.log(this.apps)
    // console.log("GitApp:created")
  },
  mounted() {
    // console.log(this.apps)
  }
};
</script>

<style scoped>
h1 {
  text-align: center;
}
h3 {
  margin: 0%;
  padding: 0%;
  border: 0px;
  /* background-color: blue; */
}

div.appdesc {
  background-color: beige;
}

ul {
  /* background-color:blue; */
  margin: 0;
  list-style-type: none;
}

</style>
